// import React, { useEffect }  from 'react';
// import { Autocomplete,useTheme, TextField, Menu, MenuItem, Divider, Button, Box } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import { tokens } from '../../theme/theme';
// const CustomAutocomplete = ({ 
//   label,
//   options,
//   selectedOption,
//   setSelectedOption,
//   setAnchorEl,
//   anchorEl,
//   handleOpenMenu,
//   handleCloseMenu,
//   filterText,
//   setFilterText,
//   handleSelectOption,
//   handleAddOption,
//   selectedID,
//   setSelectedID,
//   isRequired
// }) => {

//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   useEffect(() => {
//     if (selectedID && options.length > 0) {
//       const selected = options.find(option => option.id === selectedID);
//       if (selected) {
//         setSelectedOption(selected);
//       }
//     }
//   }, [selectedID, options, setSelectedOption]);



//   const filteredOptions = options.filter(option =>
//     option.description.toLowerCase().includes(filterText.toLowerCase())
//   );

//   const menuStyles = {
//     maxHeight: 150,
//     overflowY: 'auto',
//     '&::-webkit-scrollbar': {
//       width: '8px',
//     },
//     '&::-webkit-scrollbar-track': {
//        background: '#f0f0f0',
//       borderRadius: '10px',
//     },
//     '&::-webkit-scrollbar-thumb': {
//        background: '#888',
//       borderRadius: '10px',
//       '&:hover': {
//          background: '#555',
//       },
//     },
//   };

//   return (
//     <>
//     <Box style={{ color: colors.primary }}>
//     <Autocomplete
//         fullWidth
//         size="small"
       
//         options={filteredOptions}
//         getOptionLabel={(option) => option.description || ''}
//         value={selectedOption}
//         onChange={(event, newValue) => {
//           setSelectedOption(newValue);
//           if (newValue) {
//             setSelectedID(newValue.id);
//             console.log(newValue.id);
//           } else {
//             setSelectedID(null); // or set to a default value if needed
//           }
//         }}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             // label={label}
           
//             required={isRequired}
//             variant="outlined"
//             onClick={handleOpenMenu}
//             InputProps={{
//               ...params.InputProps,
//               readOnly: true,
//             }}
//           />
//         )}
//       />
//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleCloseMenu}
//         PaperProps={{
//           style: {
//             maxHeight: 300,
//             backgroundColor: colors.primary[600],
//           },
//         }}
//       >
//         <MenuItem>
//           <TextField
//             fullWidth
//             size="small"
//             label="Search"
//             variant="outlined"
//             value={filterText}
//             onChange={(e) => setFilterText(e.target.value)}
//           />
//         </MenuItem>
//         <Divider />
//         <div style={{ maxHeight: 100, overflowY: 'auto',...menuStyles }}>
//           {filteredOptions.map((option) => (
//             <MenuItem key={option.id} onClick={() => handleSelectOption(option)}>
//               {option.description}
//             </MenuItem>
//           ))}
//         </div>
//         <Divider />
//         <MenuItem onClick={handleAddOption}>
//           <Button fullWidth size="small" color="secondary" startIcon={<AddIcon />}>
//             Add New {label}
//           </Button>
//         </MenuItem>
//       </Menu>
//     </Box>
     
//     </>
//   );
// };

// export default CustomAutocomplete;



import React, { useEffect } from 'react';
import {
  Autocomplete,
  TextField,
  Menu,
  MenuItem,
  Divider,
  Button,
  Box,
  useTheme
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { tokens } from '../../theme/theme';

const CustomAutocomplete = ({
  label,
  options,
  selectedOption,
  setSelectedOption,
  setAnchorEl,
  anchorEl,
  handleOpenMenu,
  handleCloseMenu,
  filterText,
  setFilterText,
  handleSelectOption,
  handleAddOption,
  selectedID,
  setSelectedID,
  isRequired
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    if (selectedID && options.length > 0) {
      const selected = options.find((option) => option.id === selectedID);
      if (selected) {
        setSelectedOption(selected);
      }
    }
  }, [selectedID, options, setSelectedOption]);

  // const filteredOptions = options.filter((option) =>
  //   option.description.toLowerCase().includes(filterText.toLowerCase())
  // );
  const filteredOptions = (options || []).filter((option) =>
  option.description.toLowerCase().includes(filterText.toLowerCase())
);


  const menuStyles = {
    maxHeight: 150,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      background: '#f0f0f0',
      borderRadius: '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '10px',
      '&:hover': {
        background: '#555'
      }
    }
  };

  return (
    <Box style={{ color: colors.primary }}>
      <Autocomplete
        fullWidth
        size="small"
        options={filteredOptions}
        getOptionLabel={(option) => option.description || ''}
        value={selectedOption || null}
        onChange={(event, newValue) => {
          if (newValue) {
            setSelectedOption(newValue);
            setSelectedID(newValue.id);
          } else {
            setSelectedOption(null);
            setSelectedID(null);
          }
          handleCloseMenu(); // close on Autocomplete select
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            required={isRequired}
            variant="outlined"
            color='secondary'
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
              handleOpenMenu(event);
            }}
            InputProps={{
              ...params.InputProps,
              readOnly: true // prevent typing, use only menu for selection
            }}
          />
        )}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            maxHeight: 300,
            backgroundColor: colors.primary[600]
          }
        }}
      >
        <MenuItem>
          <TextField
            fullWidth
            size="small"
            label="Search"
            variant="outlined"
            autoFocus
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </MenuItem>

        <Divider />

        <Box sx={{ ...menuStyles, px: 1 }}>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <MenuItem
                key={option.id}
                onClick={() => {
                  setSelectedOption(option);
                  setSelectedID(option.id);
                  handleCloseMenu();
                }}
              >
                {option.description}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>No matches</MenuItem>
          )}
        </Box>

        <Divider />

        <MenuItem onClick={() => {
          handleAddOption();
          handleCloseMenu();
        }}>
          <Button fullWidth size="small" color="secondary" startIcon={<AddIcon />}>
            Add New {label}
          </Button>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default CustomAutocomplete;

